/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GenericTaskResult_Int64 } from '../models/GenericTaskResult_Int64';
import type { Wealthlane_AwardService_AppServices_EsppAwardServices_EsppPurchaseServices_TaxCalculationResult } from '../models/Wealthlane_AwardService_AppServices_EsppAwardServices_EsppPurchaseServices_TaxCalculationResult';
import type { Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_EsppPurchaseFileImportRowDto } from '../models/Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_EsppPurchaseFileImportRowDto';
import type { Wealthlane_AwardService_EsppAwards_EsppOfferingPeriod } from '../models/Wealthlane_AwardService_EsppAwards_EsppOfferingPeriod';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class EsppPurchaseProcessingService {

    /**
     * @param purchasePeriodId 
     * @param requestBody 
     * @returns GenericTaskResult_Int64 OK
     * @throws ApiError
     */
    public static postApiAwardApiAppEsppPurchaseProcessingUpsert(
purchasePeriodId: string,
requestBody?: Array<Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_EsppPurchaseFileImportRowDto>,
): CancelablePromise<GenericTaskResult_Int64> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/espp-purchase-processing/upsert/{purchasePeriodId}',
            path: {
                'purchasePeriodId': purchasePeriodId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param participantId 
     * @param companyId 
     * @param valueTypeId 
     * @param purchaseContribution 
     * @param purchasePricePerShare 
     * @param initialShares 
     * @param gainPerShare 
     * @param initialTaxRate 
     * @param threshold 
     * @param maxIterations 
     * @param requestBody 
     * @returns Wealthlane_AwardService_AppServices_EsppAwardServices_EsppPurchaseServices_TaxCalculationResult OK
     * @throws ApiError
     */
    public static postApiAwardApiAppEsppPurchaseProcessingCalculateStableShares(
participantId?: string,
companyId?: string,
valueTypeId?: string,
purchaseContribution?: number,
purchasePricePerShare?: number,
initialShares?: number,
gainPerShare?: number,
initialTaxRate?: number,
threshold: number = 0.01,
maxIterations: number = 10,
requestBody?: Wealthlane_AwardService_EsppAwards_EsppOfferingPeriod,
): CancelablePromise<Wealthlane_AwardService_AppServices_EsppAwardServices_EsppPurchaseServices_TaxCalculationResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/espp-purchase-processing/calculate-stable-shares',
            query: {
                'participantId': participantId,
                'companyId': companyId,
                'valueTypeId': valueTypeId,
                'purchaseContribution': purchaseContribution,
                'purchasePricePerShare': purchasePricePerShare,
                'initialShares': initialShares,
                'gainPerShare': gainPerShare,
                'initialTaxRate': initialTaxRate,
                'threshold': threshold,
                'maxIterations': maxIterations,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
